(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-custom-product-legal-notice]').forEach((notice) => {
      const checkbox = notice.querySelector('[data-custom-product-legal-checkbox]');
      const error = notice.querySelector('[data-custom-product-legal-error]');
      const form = notice.closest('form');

      if (!checkbox || !error || !form) return;

      checkbox.addEventListener('change', () => {
        if (checkbox.checked) error.hidden = true;
      });

      form.addEventListener(
        'submit',
        (event) => {
          if (checkbox.checked) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          error.hidden = false;
          checkbox.focus({ preventScroll: true });
          notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        true
      );
    });
  });
})();
